import moment from 'moment';

const commonParams = {
  adults_number: 2,
  offer_type: 'A',
  duration_min: 7,
  duration_max: 15,
  page: 0,
  limit: 6,
  rating_min: 3
};

export const allInclusiveParams = {
  ...commonParams,
  departure_date: moment()
    .endOf('day')
    .unix(),
  return_date: moment()
    .add(6, 'months')
    .unix(),
  boards: 12
};

export const lastMinuteParams = {
  ...commonParams,
  departure_date: moment()
    .endOf('day')
    .unix(),
  return_date: moment()
    .add(2, 'months')
    .unix()
};

export const fromGermanyParams = {
  ...commonParams,
  departure_date: moment()
    .endOf('day')
    .unix(),
  return_date: moment()
    .add(6, 'months')
    .unix(),
  departure_airports: 'ALL_GER',
  operators: 'ALL_GER',
  dates_delta: 180
};

export const withChildrenParams = {
  ...commonParams,
  departure_date: moment()
    .endOf('day')
    .unix(),
  return_date: moment()
    .add(6, 'months')
    .unix(),
  children_ages: 7
};

export const exoticPlacesParams = {
  ...commonParams,
  departure_date: moment()
    .endOf('day')
    .unix(),
  return_date: moment()
    .add(2, 'months')
    .unix(),
  regions: '200253,200271,200352,200236'
};

export const placesWithoutPassportParams = {
  ...commonParams,
  departure_date: moment()
    .endOf('day')
    .unix(),
  return_date: moment()
    .add(2, 'months')
    .unix(),
  regions: '200217,200206,200200,200205'
};

export const paramsMap = {
  all_inclusive: allInclusiveParams,
  last_minute: lastMinuteParams,
  from_germany: fromGermanyParams,
  with_children: withChildrenParams,
  exotic_places: exoticPlacesParams,
  without_passport: placesWithoutPassportParams
};



// WEBPACK FOOTER //
// ./app/javascript/pages/home/components/offers_section/params.jsx